module.exports = __webpack_public_path__ + "static/media/03_1.dd5c6426.png";